import React from 'react';
import { Skeleton } from 'antd';

const SplashLoader = () => {
  // two sections: templates (horizontal row) and recent docs (grid)
  const templatePlaceholders = Array.from({ length: 6 });
  const docPlaceholders = Array.from({ length: 8 });

  return (
    <div className="dashboard-skeleton-main-only">
      <div className="dashboard-skeleton-inner">
        {/* template gallery skeleton */}
        <div className="skeleton-template-section">
          <Skeleton
            active
            paragraph={false}
            title={{ width: '200px', style: { height: '2.4rem' } }}
          />
          <div className="skeleton-template-cards">
            {templatePlaceholders.map((_, i) => (
              <Skeleton.Image
                active
                key={i}
                style={{ width: 110, height: 140, marginRight: '1rem' }}
              />
            ))}
          </div>
        </div>

        {/* recent documents skeleton */}
        <div className="skeleton-docs-section">
          <Skeleton
            active
            paragraph={false}
            title={{ width: '180px', style: { height: '2.4rem' } }}
          />
          <div className="dashboard-skeleton-cards">
            {docPlaceholders.map((_, i) => (
              <Skeleton.Button
                active
                key={i}
                style={{ width: '100%', height: '16.25rem' }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashLoader;
